/* eslint-disable indent */
import { GetStaticPropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SeoHead } from '../../containers/components';
import { PageBlogCategory } from '../../containers/pages/page-blog-category';
import { getPrefooterTypeData } from '../../services/bestCitiesByType';
import { getFooterCache, getNavBarCache } from '../../services/cache';
import { StrapiApi } from '../../services/strapiApi';
import {
  ArticleCategory,
  FooterSectionType,
  GetStaticPath,
  NavigationBarType,
  PageArticleType,
  PageBaseProps,
  PageSectionType,
  PageSeo,
  PreFootersType,
} from '../../types';

export interface NextPageProps {
  navBarSection: PageSectionType<NavigationBarType>;
  footerSection: PageSectionType<FooterSectionType>;
  seo: PageSeo;
  preFooterType: PreFootersType;
  page: ArticleCategory;
  articles: PageArticleType[];
  allArticles: PageArticleType[];
}

export default function NextPage(props: NextPageProps): JSX.Element {
  return (
    <>
      <SeoHead title={props.seo?.title} description={props.seo?.description} />
      <PageBlogCategory
        page={props.page}
        navBarSection={props.navBarSection}
        footerSection={props.footerSection}
        preFooterType={props.preFooterType}
        articles={props.articles}
        allArticles={props.allArticles}
        overrideLogoUrl={'/blog'}
      />
    </>
  );
}

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<PageBaseProps> {
  const { params, locale } = context;
  const navBarSection = await getNavBarCache();
  const footer = await getFooterCache();
  const page = await StrapiApi.collection_types.articleCategory(
    'fr',
    params?.category as string
  );

  const allArticles = await StrapiApi.collection_types.allArticles([], 'fr');

  const articlesForCategory = allArticles.filter((a) => {
    const categories = a.categories.data.map((c) => c.attributes);
    return categories.filter((c) => c.slug === params?.category).length > 0;
  });

  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'fr')),
      navBarSection: navBarSection,
      footerSection: footer,
      seo: page.seo,
      preFooterType: getPrefooterTypeData(),
      page: page,
      articles: articlesForCategory,
      allArticles,
    },
    revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME),
  };
}

export async function getStaticPaths(): Promise<GetStaticPath> {
  const pages: ArticleCategory[] =
    await StrapiApi.collection_types.articleCategories([], 'fr');

  return {
    paths: pages.map((page) => `/blog/${page.slug}`),
    fallback: false,
  };
}
